module.exports = __webpack_public_path__ + "static/img/store-label-hours.5d608046.png";